export default __webpack_public_path__ + "static/comment-6a11240222b2d76a9e3e939f98ce5b88.jpg";